import { FractionalTransactionPart } from "./../../proto/api_pb.d";

export interface MusicNFT {
  id?: number;
  txnId?: string;
  title: string;
  artist: string;
  description: string;
  image: string;
  song: string;
  price?: number;
  genres: string[];
  timestamp: number;
  contributors: Array<FractionalTransactionPart>;
  ownerId: string;
  state?: number;
}

export const sortOptions = [
  "Recently Created",
  "Title",
  "Artist",
  "Date Modified",
];